export default __webpack_public_path__ + "static/media/dandelion.ef4f8d8c.jpg";